import { DotLegalSelectOption } from "../common/components/dotLegalMultiSelect/DotLegalMultiSelect.types";
import { SelectableColoredItem, SelectableItem } from "../processingActivity/ProcessingActivity.types";
import { AnnualWheelActivityFramework, AnnualWheelActivityGeneralType, AnnualWheelPriority } from "./annualWheelDialog/AnnualWheelDialog.types";
import { MappedFrameworkViewModel } from "../common/components/MappedFrameworkLink.tsx";

export interface AnnualWheelViewModel {
    overdueTaskCount: number;
    plannedTaskCount: number;
    completedTaskCount: number;
    totalTaskCount: number;
    businessAreaOptions: Array<DotLegalSelectOption>;
    userOptions: Array<DotLegalSelectOption>;
    areaOptions: Array<DotLegalSelectOption>;
    annualWheelActivities: Array<AnnualWheelActivityViewModel>;
    groupCompanyOptions: Array<DotLegalSelectOption>;
    relatedActivities: Array<string>;
    tagFilterOptions: Array<SelectableColoredItem>;
    annualWheelActivityGeneralTypeOptions: Array<AnnualWheelActivityGeneralType>;
    mappedFrameworkOptions: Array<SelectableItem>;
    contractOptions: Array<DotLegalSelectOption>;
}

export interface AnnualWheelActivityViewModel {
    id: string;
    date: Date;
    month: AnnualWheelMonthEnum;
    taskStatus: TaskStateEnum;
    name: string;
    deleted: boolean;
    templateId: string;
    isCustomTemplateActivity: boolean;
    description: string;
    recurringInterval?: number;
    recurringIntervalType?: number;
    priority: AnnualWheelPriority;
    businessAreas: Array<SelectableColoredItem>;
    responsibles: Array<SelectableItem>;
    areas: Array<SelectableItem>;
    customId: string | null;
    groupCompanies: Array<SelectableItem>;
    tags: Array<SelectableColoredItem>;
    notPartOfCurrentPlan: boolean;
    generalType?: AnnualWheelActivityGeneralType | undefined;
    onFrameworkControl: boolean;
    subTasks: Array<string>;
    mappedFrameworks: Array<MappedFrameworkViewModel>;
    contractId?: string | undefined;
    contractName?: string;
    startDate?: Date;
    endDate?: Date;
}

export interface AnnualWheelActivityTableModel extends AnnualWheelActivityViewModel {
    tagsString: string;
    businessAreaString: string;
    complianceAreaString: string;
    statusString: string;
    priorityString: string;
    dateString: string;
    recurringIntervalString: string;
    groupCompaniesString: string;
    mappedFrameworkString: string;
    generalTypeString: string;
    responsiblesString: string;
    subTaskCount: number;
}

export enum AnnualWheelMonthEnum {
    January = 1,
    February = 2,
    March = 3,
    April = 4,
    May = 5,
    June = 6,
    July = 7,
    August = 8,
    September = 9,
    October = 10,
    November = 11,
    December = 12,
}

export enum TaskStateEnum {
    Ready = 1,
    InProgress = 2,
    Completed = 3,
    Overdue = 4,
}

export enum TaskRawStateEnum {
    Ready = 1,
    InProgress = 2,
    Completed = 3,
    ReadyForApproval = 5,
}

export enum TaskLaneStateEnum {
    Ready = 1,
    InProgress = 2,
    Completed = 3,
}

export enum TabStep {
    GDPRTemplates = 0,
    NIS2 = 1,
    MyActivities = 2,
}

export enum NIS2Type {
    Implementation = 0,
    OngoingOperation = 1,
}

export enum ApprovalOption {
    ApprovalNotRequired = 1,
    ApprovalNotRequiredResponsibleGetNotified = 2,
    ApprovalRequiredByResponsible = 3,
}

export interface DeleteAnnualWheelActivityTemplateResponse {
    success: boolean;
}

export enum RecurringIntervalType {
    Week = 2,
    Month = 3,
    Year = 4,
}

export interface GroupCompanyResponsible {
    userId: string | null;
    groupCompanyId: string;
}

export interface SelectableAreaItem extends SelectableItem {
    framework?: AnnualWheelActivityFramework;
}
